import * as React from "react";
const SvgPayment = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M23.1 2.338c0-.014 0-.028-.028-.042-.308-.392-.714-.602-1.19-.602-.742 0-1.638.49-2.604 1.526-1.148 1.232-2.912 1.134-3.92-.21l-1.414-1.876C13.384.378 12.642 0 11.9 0s-1.484.378-2.044 1.134l-1.428 1.89c-.994 1.33-2.744 1.428-3.892.21l-.014-.014C2.94 1.526 1.526 1.274.728 2.296.7 2.31.7 2.324.7 2.338.196 3.416 0 4.928 0 7.056v13.888c0 2.128.196 3.64.7 4.718 0 .014.014.042.028.056.812 1.008 2.212.756 3.794-.938l.014-.014c1.148-1.218 2.898-1.12 3.892.21l1.428 1.89c.56.756 1.302 1.134 2.044 1.134s1.484-.378 2.044-1.134l1.414-1.876c1.008-1.344 2.772-1.442 3.92-.21.966 1.036 1.862 1.526 2.604 1.526.476 0 .882-.196 1.19-.588a.1.1 0 0 0 .028-.056c.504-1.078.7-2.59.7-4.718V7.056c0-2.128-.196-3.64-.7-4.718M15.4 17.5H7c-.574 0-1.05-.476-1.05-1.05S6.426 15.4 7 15.4h8.4c.574 0 1.05.476 1.05 1.05s-.476 1.05-1.05 1.05m2.8-4.9H7c-.574 0-1.05-.476-1.05-1.05S6.426 10.5 7 10.5h11.2c.574 0 1.05.476 1.05 1.05s-.476 1.05-1.05 1.05"
    />
  </svg>
);
export default SvgPayment;
